// extracted by mini-css-extract-plugin
export var banner = "_re-0";
export var settingRow = "_re-2";
export var titleIcon = "_re-1";